<template>
  <div class="text-truncate">
    {{ data.value.label }}
  </div>
</template>

<script>
import BaseCellType from './Base.vue'

export default {
  name: 'ReferenceCellType',
  extends: BaseCellType,
}
</script>

<style scoped>

</style>
